import React, { useState } from 'react';
import './ToggleButton.css';

interface ToggleProps {
  title: string;
  handleToggle: (changedData: any, toggleType:string) => void;
  toggleType: string;
  isToggled?: boolean;
  isMotherAlive?: boolean;
}

const ToggleButton = (props: ToggleProps) => {


  const { title, handleToggle, toggleType, isToggled, isMotherAlive } = props;
  return (
    <div className="toggle-container">
      <label className="toggle-label">
        {title}
        {(!isMotherAlive) && (toggleType !== 'isMotherAlive' && isToggled) && <span className="required">*</span>}
        {toggleType === 'isMotherAlive' && <span className="required">*</span>}
      </label>
      <div className="toggle-buttons">
        <button
          className={`toggle-button ${isToggled ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            handleToggle(true, toggleType);
          }}
        >
          Yes
        </button>
        <button
          className={`toggle-button ${!isToggled ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            handleToggle(false, toggleType);
          }}
        >
          No
        </button>
      </div>
    </div>
  );
};
export default ToggleButton;
